// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WIjT","left":"styles_left__EXL89","desktopActions":"styles_desktopActions__V-E_6","title":"styles_title__3CSQK"};